export default __webpack_public_path__ + "62aa792dbf6bea084c7d4e811f0e5f06.png";